
import { Component, Vue } from 'vue-property-decorator'
import { entries } from '@/commons/entries'
import notify from '@/notice-center'

@Component({
  name: 'MobileEntries'
})
export default class App extends Vue {
  private showDialog = false
  private entries = [
    { img: require('@/assets/images/game-blue.png'), icon: require('@/assets/images/game-blue.png'), title: '技能大赛', otherIcon: require('@/assets/images/game-white.png') },
    { img: require('@/assets/images/training-blue.png'), icon: require('@/assets/images/training-blue.png'), title: '服务培训平台', url: 'http://train-m.tcwta.org.cn/channel.html', otherIcon: require('@/assets/images/training-white.png') },
    { img: require('@/assets/images/tool-box-blue.png'), icon: require('@/assets/images/tool-box-blue.png'), title: '工具箱', otherIcon: require('@/assets/images/tool-box-white.png') },
    { img: require('@/assets/images/result-blue.png'), icon: require('@/assets/images/result-blue.png'), title: '成果评审', otherIcon: require('@/assets/images/result-white.png') }
  ]

  private posters = [
    { icon: require('@/assets/images/03.png'), url: 'https://www.acftu.org/xwdt/ghyw/202110/t20211018_786980.html?7OkeOa4k=qAqicArjSZICuEwD27iKToD3XSB5bP9c3UMonuUklfaqqhsKH_wZqAqqMa' },
    { icon: require('@/assets/images/04.png'), url: 'https://bm.tcwta.org.cn/cp/33' }
  ]

  toDtail (url: string, index: number) {
    if (index === 1) {
      notify.showNotify('', 'warning', '请通过电脑打开该网页')
    } else {
      window.open(url)
    }
  }

  gotoPage (entry: any) {
    // console.log(entry)
    if (entry.url) {
      window.open(entry.url, '_self')
    } else {
      this.showDialog = true
    }
  }
}
